import setupFindDealerSearchBox from "../../modules/dealer-locators/find-dealer-search-box";

/**
 * Helper function to setup the map and search form for the dealer locator content slice
 * @param {*} desktopLat Used for centering on desktop
 * @param {*} desktopLng Used for centering on desktop
 * @param {*} desktopZoom Used for centering on desktop
 * @param {*} mobileLat Used for centering on mobile
 * @param {*} mobileLng Used for centering on mobile
 * @param {*} mobileZoom Used for centering on desktop
 * @param {*} mapElement Element to render the map in
 * @param {*} formElement Form element for the search functionality
 * @param {*} dealerFilter Optional filter method, return true to include the dealer, false to filter
 */
export default async function(desktopLat = 54.224299, desktopLng = -4.636547, desktopZoom = 6, mobileLat = 53.861928, mobileLng = -1.564854, mobileZoom = 5, mapElement, formElement, dealerFilter) {
    const googleClass = await GoogleMapsLoader.getMap();
    const options = {
        zoom: desktopZoom,
        mapTypeControl: true,
        mapTypeId: googleClass.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        draggable: false,
    };
    let centre_lat = typeof (window.centre_lat) === 'undefined' ? desktopLat : window.centre_lat;
    let centre_lng = typeof (window.centre_lng) === 'undefined' ? desktopLng : window.centre_lng;
    if (window.matchMedia("only screen and (max-width: 767px)").matches) {
        centre_lat = mobileLat;
        centre_lng = mobileLng;
        options.mapTypeControl = false;
        options.zoom = mobileZoom;
    }
    options.center = new googleClass.maps.LatLng(centre_lat, centre_lng);

    const map = new googleClass.maps.Map(mapElement, options);
    const infowindow = new googleClass.maps.InfoWindow();
    let marker, i;
    const locationData = await window.LocationDataLoader.get();

    for (i = 0; i < locationData.length; i++) {
        // Apply the optional dealer filter, skipping the dealer if it returns false
        if (typeof dealerFilter !== 'undefined') {
            if (dealerFilter(locationData[i]) === false) {
                continue;
            }
        }

        marker = new googleClass.maps.Marker({
            position: new googleClass.maps.LatLng(locationData[i]['lat'], locationData[i]['lng']),
            map: map,
            icon: await getMapIcon(locationData[i].brand)
        });

        googleClass.maps.event.addListener(marker, 'click', (function (marker, i) {
            return function () {
                infowindow.setContent(locationData[i]['name']);
                infowindow.open(map, marker);
            }
        })(marker, i));
    }

    googleClass.maps.event.addListener(map, 'click', function (event) {
        this.setOptions({
            scrollwheel: true,
            draggable: true,
        });
    });

    setupFindDealerSearchBox(formElement);
}


// WEBPACK FOOTER //
// ./resources/assets/js/homepages/modules/dealer-locator.js